import React, { Fragment } from 'react';
import { Col, Glyphicon, Label, Row } from 'react-bootstrap';
import { IMedicalRecordAllele } from '@nkr/models/hla/hla-medical-record-allele';

interface IProps {
    alleles: IMedicalRecordAllele[],
    antigen1Value: number,
    antigen1Name: string,
    antigen2Name: string,
    antigen2Value: number,
    antigenOptions: number[],
    title: string,
    antigenLabel: boolean,
    equivalentSignedOff: boolean,
    handleAntigenChange: (e: React.ChangeEvent<HTMLSelectElement & HTMLInputElement>) => void
}


const rowStyle = {
    border: '1px solid #e7f1fa',
    borderRadius: '5px',
    padding: '6px',
    margin: '4px 2px',
    display: 'flex',
    alignItems: 'center',
    minHeight: 78
};

const titleColStyle = {
    backgroundColor: '#e7f1fa',
    borderRadius: '5px',
    alignSelf: 'stretch',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '-6px 0 -6px -6px',
    paddingLeft: 8,
    paddingRight: 8,
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0
};

export const HlaAntigenSelectionForm = (props: IProps) => {
    var discrepancyLabel    = props.equivalentSignedOff ? 'warning' : 'danger';
    const equivalents       = (allele : IMedicalRecordAllele) => {
        return allele.isExpressed == false ? '--' : (
            <>
            {allele.primaryEquivalent}
            {allele.serologicalEquivalents.length > 1 &&
                <span title={allele.serologicalEquivalents.join(', ')}>
                    <Glyphicon glyph='info-sign' style={{ marginLeft: 5 }} />
                </span>
            }
            </>
        );
    }

    return (
        <>
            <Col xs={12} lg={12}>
                <Row style={rowStyle}>
                    <Col xs={1} lg={1} style={titleColStyle}>
                        <label htmlFor={props.title}>{props.title}</label>
                    </Col>
                    <Col xs={1} lg={1} style={{ minWidth: 110 }}>
                        <label htmlFor={props.antigen1Name} style={{ display: 'block' }}>
                            {props.antigenLabel ? 'Antigen-1' : 'Low Res 1'}
                        </label>

                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <select
                                id={props.antigen1Name}
                                name={props.antigen1Name}
                                className='form-control'
                                value={props.antigen1Value}
                                onChange={props.handleAntigenChange}
                                style={{ width: '100%' }}
                            >
                                <option value='0'>Select</option>
                                {props.antigenOptions.map(a => (
                                    <option key={'a1-' + a} value={a}>
                                        {a}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </Col>
                    <Col xs={1} lg={1} style={{ minWidth: 110 }}>
                        <label htmlFor={props.antigen2Name}>{props.antigenLabel ? 'Antigen-2' : 'Low Res 2'}</label><br />

                        <select id={props.antigen2Name} name={props.antigen2Name} className='form-control' value={props.antigen2Value} onChange={props.handleAntigenChange}>
                            <option value='0'>Select</option>
                            <option value='-1'>No 2nd Antigen</option>
                            {props.antigenOptions.map(a =>
                                <option key={'a2-' + a} value={a}>{a}</option>
                            )}
                        </select>
                    </Col>

                    {[0, 1].map(idx => {
                        const a = props.alleles.find(x => x.locusGroupIndex === idx + 1);
                        const pairStyle = idx === 1
                            ? { borderLeft: '1px solid #d0d7de', paddingLeft: 12, marginLeft: 8 }
                            : undefined;
                        return (
                            <Fragment key={`slot-${idx}`}>
                            <Col xs={2} lg={2} style={pairStyle}>
                                <label>Allele {idx + 1}</label>
                                <br />
                                {a ? (
                                    <Label
                                        bsStyle={a.isExpressed ? 'info' : 'default'}
                                        style={{
                                            fontSize: "14px",
                                            padding: "5px 10px",
                                            display: "inline-block"
                                        }}
                                    >
                                        {a.alleleDetail}
                                    </Label>
                                ) : (
                                    <span style={{ color: '#999', fontStyle: 'italic', fontSize: 12 }}>—</span>
                                )}
                            </Col>
                            <Col xs={2} lg={2}>
                                <label>Expected&nbsp;Antigen</label>
                                <br />
                                {a ? (
                                    <Label
                                        bsStyle={a.noMismatch ? 'success' : (a.primaryEquivalent ?? 0) > 0 ? discrepancyLabel : 'warning'}
                                        style={{
                                            fontSize: "14px",
                                            padding: "5px 10px",
                                            display: "inline-block"
                                        }}
                                    >
                                        {equivalents(a)}
                                    </Label>
                                ) : (
                                    <span style={{ color: '#999', fontStyle: 'italic', fontSize: 12 }}>—</span>
                                )}
                            </Col>
                            </Fragment>
                        );
                    })}

                </Row>
            </Col>
        </>
    )
}